import { render, staticRenderFns } from "./ChatGptConfigModal.vue?vue&type=template&id=237aa3a7&"
import script from "./ChatGptConfigModal.vue?vue&type=script&lang=js&"
export * from "./ChatGptConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatGptConfigModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/ChatGptConfigModal.vue
// module id = 2327
// module chunks = 1